import styled from 'styled-components';
import { white } from '../../../style/colors';

const Container = styled.div`
  background: linear-gradient(to bottom, ${white} 0%, #fafafa 100%);
  margin-top: 24px;
  padding: 28px 32px;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 32px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e8e8e8;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #d1d5db;
  }
`;

export const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 180px;
`;

export const MiddleSection = styled.div`
  flex: 1;
  max-width: 500px;
`;

export const RightSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 220px;
`;

export default Container;
